import { z } from 'zod';

export const ZIP_CODE_REGEX = /^\d{5}(-\d{4})?$/;

export const zipCodeValidationMessages = {
  invalid: 'Please enter valid 5-digit zip code',
  required: 'Required',
};

export const zipCodeSchema = z
  .string()
  .min(1, { error: zipCodeValidationMessages.required })
  .regex(ZIP_CODE_REGEX, { error: zipCodeValidationMessages.invalid });
